import { faPlay } from '@fortawesome/pro-solid-svg-icons/faPlay'
import { useMediaQuery } from '@hotmart/space-lib/dist/hooks'
import { ThemeMode } from '@hotmart/space-lib/dist/styles/themes/enum'
import clsx from 'clsx'
import { ScreenSizes } from 'src/styles'
import { useCookie } from 'src/hook/useCookie'
import { CustomAudioWrapper, CustomIcon } from '../../audioPlayer.styles'
import { Divider } from './audioPlayerPreview.styles'

function AudioPlayerPreview() {
  const isMobile = useMediaQuery(`(max-width: ${ScreenSizes.sm})`)
  const { value: theme } = useCookie<ThemeMode>({
    name: 'theme',
    defaultValue: ThemeMode.DARK,
    observeChanges: true
  })

  return (
    <CustomAudioWrapper
      data-test="audio-player-preview"
      className={clsx('_mt-5 _d-flex _align-items-center _border', {
        '_bg-black': theme === ThemeMode.DARK,
        '_bg-white': theme === ThemeMode.LIGHT,
        '_py-3 _px-4': !isMobile,
        '_py-2 _px-3': isMobile
      })}
    >
      <CustomIcon icon={faPlay} />
      <Divider />
    </CustomAudioWrapper>
  )
}

export default AudioPlayerPreview
